/* Shared KAO page interactions. Safe to initialize again after theme-editor section reloads. */
(function () {
  'use strict';
  var initializedAbout = new WeakSet();
  var initializedProducts = new WeakSet();
  function initializeKao() {

(function () {
  var root = document.querySelector('.kao-about');

  if (!root || initializedAbout.has(root)) return;
  initializedAbout.add(root);

  var track = root.querySelector('[data-icons-track]');
  var prev = root.querySelector('[data-icons-prev]');
  var next = root.querySelector('[data-icons-next]');

  if (!track || !prev || !next) return;

  prev.addEventListener('click', function () {
    track.scrollBy({
      left: -260,
      behavior: 'smooth'
    });
  });

  next.addEventListener('click', function () {
    track.scrollBy({
      left: 260,
      behavior: 'smooth'
    });
  });
})();


(function () {
  document.querySelectorAll('.kao-pdp').forEach(function (root) {
    if (initializedProducts.has(root)) return;
    initializedProducts.add(root);
    var ribbon = root.querySelector('[data-ribbon-url]');
    if (ribbon) ribbon.style.backgroundImage = 'url(' + JSON.stringify(ribbon.dataset.ribbonUrl) + ')';
    var qtyInput = root.querySelector('[data-qty-input]');
    var qtyHidden = root.querySelector('[data-quantity-hidden]');
    var totalEl = root.querySelector('[data-qty-total]');
    var sellingPlanInput = root.querySelector('[data-selling-plan-input]');
    var purchaseOptions = root.querySelector('[data-type-tabs]');
    var fallbackPrice = purchaseOptions
      ? parseInt(purchaseOptions.getAttribute('data-unit-price'), 10) || 0
      : 0;

    var freqWrap = root.querySelector('[data-freq-wrap]');
    var freqSelect = root.querySelector('[data-freq-select]');
    var typeButtons = root.querySelectorAll('[data-type-btn]');
    var subscriptionPrice = root.querySelector('[data-subscription-price]');
    var addButton = root.querySelector('[data-add-to-cart]');
    var wylTrack = root.querySelector('[data-wyl-track]');
    var scrollDot = root.querySelector('[data-scroll-dot]');

    var state = {
      purchaseType: 'onetime'
    };

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function getSubscriptionPrice() {
      if (!freqSelect || !freqSelect.selectedOptions.length) {
        return fallbackPrice;
      }

      return (
        parseInt(
          freqSelect.selectedOptions[0].getAttribute('data-price'),
          10
        ) || fallbackPrice
      );
    }

    function currentUnitPrice() {
      if (state.purchaseType === 'subscribe') {
        return getSubscriptionPrice();
      }

      return fallbackPrice;
    }

    function updateSubscriptionDisplay() {
      if (!subscriptionPrice) return;

      subscriptionPrice.textContent = formatMoney(
        getSubscriptionPrice()
      );
    }

    function updateTotal() {
      var quantity = parseInt(qtyInput.value, 10) || 1;

      if (quantity < 1) {
        quantity = 1;
      }

      qtyInput.value = quantity;

      var unitPrice = currentUnitPrice();
      var totalBars = quantity;
      var totalPrice = unitPrice * quantity;

      if (qtyHidden) {
        qtyHidden.value = totalBars;
      }

      if (totalEl) {
        totalEl.textContent = formatMoney(
          Math.round(totalPrice)
        );
      }
    }

    typeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;

        typeButtons.forEach(function (item) {
          item.classList.remove('is-active');
        });

        button.classList.add('is-active');

        state.purchaseType =
          button.getAttribute('data-type-btn');

        var subscribing =
          state.purchaseType === 'subscribe';

        if (freqWrap) {
          freqWrap.hidden = !subscribing;
        }

        if (sellingPlanInput) {
          sellingPlanInput.value =
            subscribing && freqSelect
              ? freqSelect.value
              : '';
        }

        updateSubscriptionDisplay();
        updateTotal();
      });
    });

    if (freqSelect) {
      freqSelect.addEventListener('change', function () {
        if (
          sellingPlanInput &&
          state.purchaseType === 'subscribe'
        ) {
          sellingPlanInput.value = freqSelect.value;
        }

        updateSubscriptionDisplay();
        updateTotal();
      });
    }

    var decrement = root.querySelector('[data-qty-dec]');
    var increment = root.querySelector('[data-qty-inc]');

    if (decrement) {
      decrement.addEventListener('click', function () {
        var value =
          parseInt(qtyInput.value, 10) || 1;

        qtyInput.value = Math.max(1, value - 1);

        updateTotal();
      });
    }

    if (increment) {
      increment.addEventListener('click', function () {
        var value =
          parseInt(qtyInput.value, 10) || 1;

        qtyInput.value = value + 1;

        updateTotal();
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('input', function () {
        qtyInput.value =
          qtyInput.value.replace(/[^0-9]/g, '');

        updateTotal();
      });

      qtyInput.addEventListener('blur', function () {
        if (!parseInt(qtyInput.value, 10)) {
          qtyInput.value = 1;
        }

        updateTotal();
      });
    }

    var form = addButton
      ? addButton.closest('form')
      : null;

    if (form && addButton) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();

        addButton.disabled = true;

        var originalText = addButton.textContent;

        addButton.textContent = 'ADDING…';

        var formData = new FormData(form);

        if (!formData.get('selling_plan')) {
          formData.delete('selling_plan');
        }

        var cartRoot =
          window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root
            ? window.Shopify.routes.root
            : '/';

        fetch(cartRoot + 'cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          },
          body: formData
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Cart request failed');
            }

            return response.json();
          })
          .then(function () {
            addButton.textContent = 'ADDED!';

            setTimeout(function () {
              addButton.textContent = originalText;
              addButton.disabled = false;
            }, 1400);

            document.dispatchEvent(
              new CustomEvent('cart:refresh')
            );

            document.dispatchEvent(
              new CustomEvent('cart:updated')
            );
          })
          .catch(function () {
            addButton.textContent = originalText;
            addButton.disabled = false;

            form.submit();
          });
      });
    }

    function updateWylScrollIndicator() {
      if (!wylTrack || !scrollDot) return;

      var scrollable =
        wylTrack.scrollWidth -
        wylTrack.clientWidth;

      if (scrollable <= 0) {
        scrollDot.style.transform =
          'translateX(0)';
        return;
      }

      var progress =
        wylTrack.scrollLeft /
        scrollable;

      var travel = 58;

      scrollDot.style.transform =
        'translateX(' +
        Math.round(progress * travel) +
        'px)';
    }

    if (wylTrack) {
      wylTrack.addEventListener(
        'scroll',
        updateWylScrollIndicator,
        { passive: true }
      );

      window.addEventListener(
        'resize',
        updateWylScrollIndicator
      );

      updateWylScrollIndicator();
    }

    if (wylTrack) {
      var wylIsDown = false;
      var wylDragged = false;
      var wylStartX = 0;
      var wylStartScroll = 0;

      wylTrack.addEventListener('mousedown', function (e) {
        wylIsDown = true;
        wylDragged = false;
        wylTrack.classList.add('is-dragging');
        wylStartX = e.pageX;
        wylStartScroll = wylTrack.scrollLeft;
      });

      window.addEventListener('mouseup', function () {
        if (!wylIsDown) return;
        wylIsDown = false;
        wylTrack.classList.remove('is-dragging');
      });

      window.addEventListener('mousemove', function (e) {
        if (!wylIsDown) return;
        e.preventDefault();
        var delta = e.pageX - wylStartX;
        if (Math.abs(delta) > 3) wylDragged = true;
        wylTrack.scrollLeft = wylStartScroll - delta;
      });

      wylTrack.addEventListener(
        'click',
        function (e) {
          if (wylDragged) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );
    }

    updateSubscriptionDisplay();
    updateTotal();
  });
})();

  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeKao, { once: true });
  else initializeKao();
  document.addEventListener('shopify:section:load', initializeKao);
})();
